import { Footer } from '@ifca-root/react-component/src/components/Footer/Footer';
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader';
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper';
import Loading from '@ifca-root/react-component/src/components/Loading/Loading';
import { useMediaQuery } from '@ifca-root/react-component/src/helpers/PDFFormatter/mediaSize';
import { Pagination } from '@material-ui/lab';
import { Group, drawDOM, exportPDF } from '@progress/kendo-drawing';
import ShareDialog from 'components/Dialog/ShareDialog';
import saveAs from 'file-saver';
import { useMobilePDFZoom } from 'helpers/Hooks/useMobilePDFZoom';
import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router';
import {
  useGetShareAttachmentMutation,
  useGetUsersByAccountAndSoftwareQuery,
} from '../../generated/graphql';
import GPBodyTemplate from './BodyTemplate/GPBodyTemplate';
import './PDFStyle.scss';
import { useGPQueries } from './useGPQueries';
import { ELetterPreview } from '@account-root/account-react/src/containers/ARModule/Hooks/ELetterTemplate/ELetterPreview';
import { groupItemDataForPreview } from '@account-root/account-react/src/containers/ARModule/Hooks/ELetterTemplate/ELetterService';
import { ErrorDialog } from 'components/Dialog/ErrorDialog';
import * as htmlToImage from 'html-to-image';
import ShareIcon from '@material-ui/icons/Share';

export const PDFPreviewGP = (_props: any) => {
  const user = JSON.parse(localStorage.getItem('loggedInUser'));
  const [width] = useMediaQuery();

  let history = useHistory();
  const { styles } = useMobilePDFZoom();

  const {
    CompanyID,
    PRHeaderID,
    POHeaderID,
    GRTNHeaderID,
    DOHeaderID,
    RFQHeaderID,
  }: any = useParams();
  const { accountType, docType, backPath } = _props;

  const [errMessage, setErrMessage] = useState(null);
  const [errDialog, setErrDialog] = useState(false);

  let fontSize;
  if (width < 769) fontSize = 7;
  else fontSize = 10;

  let descriptionSize;
  if (width < 769) {
    descriptionSize = 6;
  } else {
    descriptionSize = 9;
  }

  let fontStyle;
  fontStyle = { fontSize: fontSize, textAlign: 'center' };

  let routeSegments;
  let title;
  let smTitle;
  let DocumentID;
  let itemName;
  let eLetter = false;
  switch (accountType) {
    case '/':
      smTitle = 'General Purchases';
      switch (docType) {
        // PO and PR
        case 'generate-po-from-pr':
          routeSegments = 'Purchase Order';
          title = 'PURCHASE ORDER';
          DocumentID = POHeaderID;
          itemName = 'POItem';
          eLetter = true;
          break;
        case 'direct-po':
          routeSegments = 'Purchase Order';
          title = 'PURCHASE ORDER';
          DocumentID = POHeaderID;
          itemName = 'POItemGroup';
          eLetter = true;
          break;
        case 'centralised-po':
          routeSegments = 'Purchase Order';
          title = 'PURCHASE ORDER';
          DocumentID = POHeaderID;
          itemName = 'POItem';
          eLetter = true;
          break;
        case 'purchase-requisition':
          routeSegments = 'Purchase Requisition';
          title = 'PURCHASE REQUISITION';
          DocumentID = PRHeaderID;
          itemName = 'PRItem';
          eLetter = true;
          break;
        case 'rfq':
          routeSegments = 'Request for Quotation';
          title = 'QUOTATION';
          DocumentID = RFQHeaderID;
          itemName = 'RFQItem';
          break;
        // GRTN and GRN
        case 'good-return-note':
          routeSegments = 'Goods Return Note';
          title = 'GOODS RETURN NOTE';
          DocumentID = GRTNHeaderID;
          itemName = 'GRTNHeaderItem';
          eLetter = true;
          break;
        case 'delivery-order':
          routeSegments = 'Goods Receive Note';
          title = 'GOODS RECEIVE NOTE';
          DocumentID = DOHeaderID;
          itemName = 'DOItem';
          eLetter = true;
          break;
        default:
          break;
      }
      switch (backPath) {
        case 'purchase-requisition':
          break;
        case 'direct-po':
          break;
      }
      break;
  }

  const {
    queryLoading,
    listData,
    primaryKey,
    templateBody,
    errMessage: errMsg,
    errDialog: errDia,
    setErrDialog: setErrDia,
  } = useGPQueries({ docType, CompanyID, transactionID: DocumentID });

  let previewDetail;

  if (docType === 'direct-po') {
    if (listData?.length > 0 && !!templateBody) {
      const groupKeys = [
        'ItemDescription',
        'ItemRemark',
        'Department',
        'UOM',
        'UnitPrice',
        'DeptCd',
        'DeptCtNm',
        'DeptCtCd',
      ];

      const dataItem = listData[0]?.POItem?.map(el => {
        return {
          ItemDescription: el?.Item?.Name,
          ItemRemark: el?.Remarks,
          Department: el?.CostCentre?.Name,
          DeptCd: el?.CostCentre?.Code,
          DeptCtNm: el?.CostCentre?.FirstCostCentre?.Name,
          DeptCtCd: el?.CostCentre?.FirstCostCentre?.Code,
          UOM: el?.UOM?.Code,
          Quantity: Number(el?.OrderedQty),
          UnitPrice: Number(el?.UnitPrice),
          BaseAmt: Number(el?.BaseAmt),
          TaxAmt: Number(el?.TaxAmt),
          TotalAmt: Number(el?.TotalAmt),
        };
      });

      const groupDataItem = groupItemDataForPreview({
        templateBody,
        groupKeys,
        dataItem,
      });

      previewDetail = listData[0];
      if (groupDataItem?.length > 0) {
        previewDetail['POItemGroup'] = groupDataItem;
      }
    }
  } else {
    previewDetail = listData[0];
  }

  interface InfoTemplateRight {
    title: string;
    data: string;
  }
  const InfoTemplateRight = ({ title, data }: InfoTemplateRight) => {
    return (
      <div style={{ paddingLeft: '20%' }}>
        <div style={{ width: '40%', display: 'inline-flex' }}>{`${title}`}</div>
        <div style={{ width: '10%', display: 'inline-flex' }}>:</div>
        <div style={{ width: '50%', display: 'inline-flex' }}>{data}</div>
      </div>
    );
  };

  const {
    loading: UserLoading,
    data: { getUsersByAccountAndSoftware } = {
      getUsersByAccountAndSoftware: [],
    },
  } = useGetUsersByAccountAndSoftwareQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15);
      setErrMessage(error);
      setErrDialog(true);
    },
  });

  // ========== Page definition ==========

  const [page, setCurrentPage] = useState<number>(0);

  // ========== Threshold definition ==========
  let totalItems = previewDetail?.[itemName]?.length;

  let threshold;
  if (totalItems > 15) {
    threshold = 15;
  } else {
    threshold = 0;
  }

  useEffect(() => {
    if (!!previewDetail) separateThreshold(previewDetail);
  }, [previewDetail]);

  // ========== Remap Data for item list ==========
  const [remapData, setRemapData] = useState(null);

  const separateThreshold = input => {
    let temp = [];
    let noChange = [];
    let tempItem = [];

    previewDetail?.[itemName]?.map((v, i) => {
      tempItem.push({ ...v, index: i + 1 });
      if ((i + 1) % threshold === 0) {
        temp.push({ ...input, [itemName]: tempItem });
        tempItem = [];
      } else if (previewDetail?.[itemName]?.length === i + 1) {
        temp.push({ ...input, [itemName]: tempItem });
      }
    });
    noChange.push(temp);
    temp = [];
    return setRemapData(noChange.flat());
  };

  /// ========== kendo-drawing PDF Download ===========
  const dataURItoFile = (dataurl, filename) => {
    dataurl.replace('data:application/pdf;base64,', '');
    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  };

  const onPrint = () => {
    let element = document.getElementById('pdf-data-print');

    drawDOM(element, {
      paperSize: 'A4',
      margin: {
        bottom: '1cm',
        top: '1cm',
        left: '0.5cm',
        right: '0.5cm',
      },
      scale: eLetter === true ? 0.72 : width < 769 ? 1.3 : 0.85,
      forcePageBreak: '.page-break',
    })
      .then((group: Group) => exportPDF(group))
      .then(dataURI => {
        let fileObject = dataURItoFile(
          dataURI,
          `${title} (${previewDetail?.DocNo}).pdf`,
        );
        saveAs(fileObject, `${title} (${previewDetail?.DocNo}).pdf`);
      });
  };

  /* ========================================= */
  /* DOCS THAT IS SAVED AS PDF WHICH IS HIDDEN */
  /* ========================================= */
  const pdfToPrint = () => {
    return (
      <>
        <div style={{ position: 'fixed', left: `-1000px` }}>
          <div id={'pdf-data-print'}>
            {remapData &&
              remapData?.map((v, index) => {
                if (eLetter === true) {
                  return (
                    <ELetterPreview
                      fontStyle={fontStyle}
                      title={title}
                      previewDetail={previewDetail}
                      accountType={accountType}
                      docType={docType}
                      itemName={itemName}
                      getUsersByAccountAndSoftware={
                        getUsersByAccountAndSoftware
                      }
                      remapData={remapData}
                      page={index}
                      pageLength={remapData?.length}
                      htmlTemplate={templateBody}
                      threshold={threshold}
                    />
                  );
                } else {
                  return (
                    <GPBodyTemplate
                      accountType={accountType}
                      fontStyle={fontStyle}
                      fontSize={fontSize}
                      descriptionSize={descriptionSize}
                      title={title}
                      docType={docType}
                      previewDetail={previewDetail}
                      getUsersByAccountAndSoftware={
                        getUsersByAccountAndSoftware
                      }
                      remapData={remapData}
                      page={index}
                      pageLength={remapData?.length}
                      companyCountry={user?.companyAddress?.Address?.country}
                    />
                  );
                }
              })}
          </div>
        </div>
      </>
    );
  };

  const [openShareDialog, setOpenShareDialog] = useState(false);
  const [openSendEmail, setOpenSendEmail] = useState(false);

  const [
    getShareAttachments,
    {
      data: { getShareAttachment } = { getShareAttachment: {} as any },
      loading: ShareAttachmentLoading,
    },
  ] = useGetShareAttachmentMutation({
    onError: ({ message }) => {
      let error = message?.substring(15);
      setErrMessage(error);
      setErrDialog(true);
    },
    onCompleted: () => {
      setOpenShareDialog(true);
    },
  });

  const onSubmit = blob => {
    getShareAttachments({ variables: { file: blob, CompanyID: CompanyID } });
  };

  return (
    <>
      {UserLoading && <Loading />}
      {queryLoading && <Loading />}
      {ShareAttachmentLoading && <Loading />}
      <MainHeader
        mainBtn="back"
        onClick={() => {
          history.push(`/general-purchase/${CompanyID}/${backPath}`);
        }}
        smTitle={'General Purchases'}
        title={user?.companyName}
        routeSegments={[
          { name: `${smTitle}` },
          { name: `${routeSegments}` },
          { name: `${routeSegments}`, current: true },
        ]}
      />
      <ContentWrapper footer>
        <div
          style={eLetter === false ? { height: window.screen.height } : null}
        >
          <div style={eLetter === false ? styles.supercontainer : null}>
            <div style={eLetter === false ? styles.container : null}>
              {previewDetail &&
                remapData &&
                (eLetter === true ? (
                  <ELetterPreview
                    fontStyle={fontStyle}
                    title={title}
                    previewDetail={previewDetail}
                    accountType={accountType}
                    docType={docType}
                    itemName={itemName}
                    getUsersByAccountAndSoftware={getUsersByAccountAndSoftware}
                    remapData={remapData}
                    page={page}
                    pageLength={remapData?.length ?? 1}
                    htmlTemplate={templateBody}
                    isView={true}
                    threshold={threshold}
                  />
                ) : (
                  <GPBodyTemplate
                    accountType={accountType}
                    fontStyle={fontStyle}
                    fontSize={fontSize}
                    descriptionSize={descriptionSize}
                    title={title}
                    docType={docType}
                    previewDetail={previewDetail}
                    getUsersByAccountAndSoftware={getUsersByAccountAndSoftware}
                    remapData={remapData}
                    page={page}
                    pageLength={remapData?.length}
                    companyCountry={user?.companyAddress?.country}
                  />
                ))}
            </div>
          </div>
        </div>
        <div className={`pagination-dis-${width < 769 ? 'mobile' : 'desktop'}`}>
          <Pagination
            count={remapData?.length}
            shape="rounded"
            page={page + 1}
            onChange={(e, page) => {
              setCurrentPage(page - 1);
            }}
          />
        </div>
        {pdfToPrint()}
      </ContentWrapper>
      {ShareDialog({
        shareTitle: `General Purchases(${routeSegments}) - ${user?.companyName}`,
        title: `Share`,
        URL: getShareAttachment?.fileURL,
        setSimple: setOpenShareDialog,
        simple: openShareDialog,
        emailShare: openSendEmail,
        setSimpleEmail: setOpenSendEmail,
      })}
      <Footer
        options={[
          {
            name: 'Share',
            onClick: async () => {
              let temp = await document.getElementById('pdf-data-print');

              htmlToImage
                .toBlob(temp, { style: { background: '#fff' } })
                .then(value => {
                  onSubmit(value);
                })
                .catch(error => console.error(error, 'Something went wrong'));
            },
            color: 'primary',
            props: {
              type: 'submit',
            },

            startIcon: <ShareIcon style={{ fontSize: '18px' }} />,
          },
          {
            name: 'Download',
            onClick: () => {
              onPrint();
            },
            color: 'primary',
          },
        ]}
      />
      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />
      <ErrorDialog
        errorDia={errDia}
        setErrorDia={setErrDia}
        errorMsg={errMsg}
        errorHeaderMsg={'Error!'}
      />
    </>
  );
};
